<!--
 * @FileDescription: 文字介绍轮播组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 12:56:21
 -->
<template>
  <DvBorderBox2 class="desc-template" :order="order" :keyValId="keyValId">
    <!-- <div class="desc-container" v-if="keyValId == '2'">
      <el-carousel height="100%" class="desc-carousel" ref="descCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in descInfo1" :key="item.name">
          <div class="desc-box">
            <div class="desc-title">{{ item.name }}</div>
            <div class="desc-content">{{ item.desc }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <!-- json改完后 -->
    <div class="desc-container" v-if="keyValId == '2'">
      <el-carousel height="100%" class="desc-carousel" ref="descCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in descInfo2" :key="item.properties.name">
          <div class="desc-box">
            <div class="desc-title">{{ item.properties.name }}</div>
            <el-scrollbar class="desc-content-scroll">
              <div class="desc-content">{{ item.properties.desc }}</div>
            </el-scrollbar>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- <div class="desc-container" v-else-if="keyValId == '3'">
      <el-carousel height="100%" class="desc-carousel" ref="descCarousel" indicator-position="none" :autoplay="false">
        <el-carousel-item v-for="item in descInfo2" :key="item.name">
          <div class="desc-box">
            <div class="desc-title">{{ item.name }}</div>
            <div class="desc-content">{{ item.desc }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div> -->
  </DvBorderBox2>
</template>

<script>
export default {
  name: 'DescribeTemplate',
}
</script>

<script setup>
import { defineProps, watch, ref, onMounted } from 'vue';
import { BorderBox2 as DvBorderBox2 } from '@kjgl77/datav-vue3';
// import { schoolData} from './schoolData';
// import activeJson from "@/components/activeChartData.json"
import axios from 'axios';

let props = defineProps({
  order: String,
  schoolIndex: Number,
  keyValId: String,
});
console.log('desc props', props.schoolIndex)

let descCarousel = ref();
let activeJson = ref({})
let descInfo2 = ref([])
// const order = props.order;

// const descInfo1 = schoolData;
// const descInfo2 = activeJson.unionSchoolPt.features;

onMounted(() => {
  axios.get('/activeChartData.json')
    .then(response => {
      activeJson.value = response.data;
      descInfo2.value = activeJson.value.unionSchoolPt.features
      // searchInformation.value[0]={ name: '园区', val: searchNum.value + '所' }
    })
    .catch(error => {
      console.log(error);
    });
})

// onMounted(() => {
//   descCarousel.value.setActiveItem(props.schoolIndex - 1);
// })

watch(props, (newProps) => {
  descCarousel.value.setActiveItem(newProps.schoolIndex - 1);
})

</script>


<style lang="scss" scoped>
$orders: 1, 2, 3, 4, 5, 6, 7, 8;

div.desc-template {
  &[keyValId='2'] {
    position: relative;
    // margin-top: 1vh;
    margin-bottom: 1vh;
    width: 30vw;
    height: 42vh;
    z-index: 11;
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
  }

  &[keyValId='3'] {
    position: relative;
    margin-top: 4vh;
    margin-bottom: 1vh;
    width: 25vw;
    height: 56vh;
  }

  @each $order in $orders {
    &[order='#{$order}'] {
      order: $order;
    }
  }



  div.desc-container {
    position: absolute;
    // top: 0.7%;
    // left: 0.7%;
    width: 29vw;
    height: 41vh;
    z-index: 10;
    border-radius: 8px;
    overflow: hidden;

    .desc-carousel {
      width: 29vw;
      height: 41vh;

      .el-carousel__container {
        width: 29vw;
        height: 41vh;

        .desc-box {
          position: relative;
          width: 29vw;
          height: 41vh;
          display: flex;
          flex-flow: column nowrap;
          align-items: center;
          justify-content: center;
          left: 0.5vw;
          // row-gap: 5%;

          div.desc-title {
            // margin-top: 4%;
            width: fit-content;
            height: 5vh;
            line-height: 5vh;
            vertical-align: middle;
            background-image: linear-gradient(25deg,
                #fdfffc 0%,
                #a7d3ec 40%,
                #3886eb 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-animation: hue 60s infinite linear;
            word-wrap: break-word;
            font-size: calc(0.4vh + 1vw);
            font-weight: 600;
            text-align: center;
            font-family: "Microsoft YaHei";
          }

          div.desc-content-scroll {
            // padding-left: 3%;
            // padding-right: 3%;
            height: 36vh;
            width: 28vw;
            background-image: linear-gradient(25deg,
                #f4fbff 0%,
                #c7dfed 70%,
                #a7d3ec 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            -webkit-animation: hue 60s infinite linear;
            font-size: 0.9vw;
            overflow: auto;
            // margin-bottom: 5%;

            div.desc-content {
              height: fit-content;
              align-items: center;
              justify-content: center;
              width: 28vw;
              font-size: calc(0.75vh + 0.5vw);
              overflow: auto;
            }
          }
        }
      }
    }
  }

}
</style>
